module.exports = __webpack_public_path__ + "images/1950285c9a489466a668ddca92e16c0b.gif";